module.exports = __webpack_public_path__ + "aa28abc172f95d0d2a0a5892c674b458.svg";